import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputComponent } from '../base/input.component';
import { ControlsIconsModule } from '../icons.module';

@Component({
    standalone: true,
    imports: [CommonModule, FormsModule, ControlsIconsModule],
    selector: 'wd-checkbox',
    templateUrl: 'checkbox-view.component.html',
    styleUrls: ['../styles/checkbox-view.component.css', '../styles/view.component.css', '../styles/view-only.component.css'],
})
export class CheckboxViewComponent extends InputComponent<boolean> {
	@Input() icon?: string;
}
